import React from 'react';
import PropTypes from 'prop-types';
import { Label, Input as RawInput, Container, Content } from './styles';

const Input = function ({ label, alert, forwardRef, ...otherProps }) {
  const alertIsError = alert && alert.type === 'error';

  return (
    <Container>
      <Content>
        <Label>
          {`${label} `}
          <RawInput
            type="text"
            error={alert && alert.type === 'error'}
            ref={forwardRef}
            {...otherProps}
          />
        </Label>
      </Content>
      {!!alert && (
        <Label alert error={alertIsError}>
          {alert.message}
        </Label>
      )}
    </Container>
  );
};

Input.propTypes = {
  label: PropTypes.string,
  forwardRef: PropTypes.func,
  alert: PropTypes.shape({
    message: PropTypes.string,
    type: PropTypes.oneOf(['error', 'warning']),
  }),
};

export default Input;
